module.exports = "/_next/static/images/step4-36256b55ad6286e5dca0c9395d22c047.png";